// Öffentliche Variante von /community/stream für Gäste (NT-STREAM-FIX-01).
// Zeigt nur den Live-Status der Partner-Streamer (Anzeigename, Login, Slug, isLive) plus einen
// Registrierungs-/Wartelisten-Hinweis. Eingeloggte Spieler sehen weiterhin den Dashboard-Tab.

import '../../styles/community.css';
import { api } from '../../services/api.js';
import { navigate } from '../../router.js';
import { renderPartnerSection, bindPartnerCards, type PartnerCardData } from './partner-cards.js';

interface AlphaSlots {
  remainingSlots: number;
  maxPlayers: number;
}

const POLL_INTERVAL_MS = 60_000;

let pollTimer: ReturnType<typeof setInterval> | null = null;

function esc(s: string): string {
  const d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

function renderHint(slots: AlphaSlots | null): string {
  // Spielerlimit erreicht → Warteliste (Registrierung selbst legt dann den Wartelisten-Eintrag an)
  const full = slots !== null && slots.remainingSlots <= 0;
  const text = full
    ? 'Die Alpha ist aktuell voll. Registriere dich trotzdem — du landest auf der Warteliste und rückst nach, sobald ein Platz frei wird.'
    : 'Du willst mitspielen, Punkte sammeln und Kisten öffnen? Erstelle ein Konto.';
  return `
    <div class="stream-code-section">
      <div class="stream-code-label">${full ? 'ALPHA VOLL — WARTELISTE' : 'NOCH KEIN KONTO?'}</div>
      <p class="stream-offline-sub">${esc(text)}</p>
      <div class="stream-card-actions">
        <button class="btn-stream-community" id="stream-public-register">${full ? 'AUF DIE WARTELISTE' : 'KONTO ERSTELLEN'}</button>
        <button class="btn-stream-twitch" id="stream-public-login">EINLOGGEN</button>
      </div>
    </div>`;
}

async function loadLive(): Promise<void> {
  const el = document.getElementById('stream-public-live');
  if (!el) {
    if (pollTimer !== null) { clearInterval(pollTimer); pollTimer = null; }
    return;
  }
  try {
    const cards = await api.get<PartnerCardData[]>('/community/live');
    el.innerHTML = renderPartnerSection(cards);
    bindPartnerCards(el);
  } catch {
    el.innerHTML = '<div class="stream-error">STREAM-STATUS NICHT VERFÜGBAR.</div>';
  }
}

async function loadHint(): Promise<void> {
  const el = document.getElementById('stream-public-hint');
  if (!el) return;
  let slots: AlphaSlots | null = null;
  try {
    slots = await api.get<AlphaSlots>('/alpha/slots');
  } catch {
    slots = null;
  }
  el.innerHTML = renderHint(slots);
  document.getElementById('stream-public-register')?.addEventListener('click', () => { navigate('/register'); });
  document.getElementById('stream-public-login')?.addEventListener('click', () => { navigate('/login'); });
}

export function renderPublicStream(): void {
  const app = document.getElementById('app');
  if (!app) return;

  if (pollTimer !== null) clearInterval(pollTimer);

  app.innerHTML = `
    <main class="dash-content" id="dash-stream" style="max-width:720px;margin:0 auto;padding:var(--space-4);">
      <div class="stream-header"><h2>COMMUNITY – STREAM</h2></div>
      <div id="stream-public-live"><div class="stream-loading">LADE STREAM-STATUS...</div></div>
      <div id="stream-public-hint"></div>
    </main>`;

  void loadLive();
  void loadHint();
  pollTimer = setInterval(() => { void loadLive(); }, POLL_INTERVAL_MS);
}
